module.exports = "<p>\n  medium works!\n</p>\n"


//////////////////
// WEBPACK FOOTER
// /Users/ericzayas/Documents/relativePitch/src/app/components/medium/medium.component.html
// module id = ../../../../../src/app/components/medium/medium.component.html
// module chunks = main